import { apiClient } from './client'

export interface User {
  id: string
  authentikId: string
  authentikUsername: string
  email: string
  name?: string
  avatarUrl?: string
  mattermostUserId?: string
  mattermostUsername?: string
  mattermostLinkedAt?: string
  groups?: string[]
  createdAt: string
  lastLoginAt?: string
}

export interface AuthResponse {
  user: User
}

export async function getCurrentUser(): Promise<User | null> {
  try {
    const response = await apiClient.get<AuthResponse>('/auth/me', {
      withCredentials: true,
    })
    return response.data.user
  } catch {
    // Not authenticated or error
    return null
  }
}

export function login(returnTo?: string): void {
  const params = returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ''
  window.location.href = `/auth/login${params}`
}

export function logout(): void {
  window.location.href = '/auth/logout'
}
